export default __webpack_public_path__ + "static/media/closet5-after1-1440w.d321135a.png";